<header>
  <mat-toolbar role="heading" aria-level="1">
    <mat-toolbar-row class="layout-container">
      <a matButton routerLink="/" style="height: 100%" aria-label="Go to homepage" data-testid="header-app-logo">
        <app-logo />
      </a>
      <span class="nav-spacer"></span>
      <app-language-selector />
      @if (hasToken$ | async) {
        <a routerLink="/profile" class="d-none-mobile profile-link" data-testid="header-profile-link" aria-label="Go to profile page" matButton>
          <small>{{ profile$ | async | clientIdentity }}</small>
        </a>
        <button class="menu-btn" data-testid="header-navbar-menu-button" matButton [matMenuTriggerFor]="menu" aria-label="menu">
          <app-menu-icon />
        </button>
        <mat-menu #menu="matMenu" class="alternate-theme">
          <a mat-menu-item aria-label="profile" routerLink="/profile" data-testid="header-menu-profile-link">
            <mat-icon>account_box</mat-icon>
            <span i18n="site header menu item|Profile action">Profile</span>
          </a>
          <ng-container *ngTemplateOutlet="contactsMenuItem"></ng-container>
          <button type="button" mat-menu-item aria-label="logout" (click)="logout()" data-testid="header-menu-logout-button">
            <mat-icon>logout</mat-icon>
            <span i18n="site header menu item|Logout action">Logout</span>
          </button>
        </mat-menu>
      } @else {
        <a class="d-none-mobile profile-link" routerLink="/login" data-testid="header-login-link" matButton>
          <small i18n="site header|Login message">Login</small>
        </a>
        <button class="menu-btn" data-testid="header-navbar-menu-button" matButton [matMenuTriggerFor]="menu" aria-label="menu">
          <app-menu-icon />
        </button>
        <mat-menu #menu="matMenu" class="alternate-theme">
          <button type="button" mat-menu-item aria-label="login" (click)="navigateToLogin()" data-testid="header-login-link">
            <mat-icon>login</mat-icon>
            <span i18n="site header|Login message">Login</span>
          </button>
          <!--    <button *ngIf="businessMode.isOn" type="button" mat-menu-item aria-label="private person registration" (click)="navigateToRegistration(false)">-->
          <!--      <mat-icon>person</mat-icon>-->
          <!--      <span i18n="site header|Turn off business mode">Private person</span>-->
        <!--    </button>-->
        <!--    <button *ngIf="businessMode.isOff" type="button" mat-menu-item aria-label="business registration" (click)="navigateToRegistration(true)">-->
        <!--      <mat-icon>business_center</mat-icon>-->
        <!--      <span i18n="site header|Turn on business mode">For business</span>-->
      <!--    </button>-->
      <ng-container *ngTemplateOutlet="contactsMenuItem"></ng-container>
    </mat-menu>
  }
  </mat-toolbar-row>
  </mat-toolbar>

  <ng-template #contactsMenuItem>
    <a mat-menu-item aria-label="contacts" routerLink="/contacts" data-testid="header-contacts-link">
      <mat-icon>info</mat-icon>
      <ng-container i18n="site header menu item|Contacts page">Contacts</ng-container>
    </a>
  </ng-template>
</header>
